import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

const style = {
    marginLeft: '45%'
};

export const Spinner = () => {
    return <CircularProgress style={style} disableShrink={true}/>;
};
